import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {
    Box,
    Container,
    Grid,
    Typography,
} from '@mui/material';
import { motion } from 'framer-motion';
import { About_IMG } from '../../Constants/ImageConstants';
import { COLORS } from '../../Constants/styles';
import AccentButton from '../Common/AccentButton';

const AboutSection = () => {
    const coreValues = [
        {
            title: 'Child-Centered Growth',
            description:
            'Creating joyful, age-appropriate experiences that help children grow physically, socially, and emotionally.'
        },
        {
            title: 'Empowering Coaches & Educators ',
            description:
                'Equipping coaches and teachers with practical knowledge, modern coaching methods, and continuous learning opportunities.',
        },
        {
            title: 'Stronger Sports Ecosystems ',
            description:
            'Connecting schools, communities, and organizations to create sustainable opportunities for participation and development.'
        },
    ];

    return (
        <Box sx={{ pt: 6, pb: 0 }}>
            <Container maxWidth="xl" sx={{ pb: 10, backgroundColor: COLORS.white, color: COLORS.pureBlack }}>
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.6 }}
                >
                    <Grid container spacing={6} alignItems="center">
                        <Grid item xs={12} md={6}>
                            <Box
                                component="img"
                                src={About_IMG.aboutExplore}
                                alt="Children exercising together during a school sports session"
                                sx={{
                                    width: '100%',
                                    height: { xs: 250, sm: 300, md: 450 },
                                    objectFit: 'cover',
                                    borderRadius: '24px',
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="h5" sx={{ mb: 2 }}>ABOUT US </Typography>
                            <Typography variant="h3" sx={{ mb: 3 }}>
                                Building Better Futures Through Sport 
                            </Typography>
                            <Typography variant="body2" paragraph sx={{ mb: 2, lineHeight: '1.5em' }}>
                                At Grassroots Sports Education & Services, we believe sport is more than physical activity—it is a powerful platform for learning, character development, health, and lifelong confidence. 
                            </Typography>
                            <Typography variant="body2" paragraph sx={{ mb: 4 }}>
                                We partner with schools, educators, coaches, and communities to deliver structured Sports & Physical Education through curriculum-aligned programs, multimedia learning resources, coach education, and innovative sports solutions. Every initiative is designed to inspire joyful childhoods, nurture holistic development, and strengthen the grassroots sports ecosystem. 

                            </Typography>
                            <AccentButton label="Explore Our Programs" href="/ourservices" />
                        </Grid>
                    </Grid>
                </motion.div>
            </Container>

            <Box sx={{ backgroundColor: COLORS.greyBG, color: COLORS.pureBlack }}>
                <Container maxWidth="xl" sx={{ py: 6, backgroundColor: COLORS.greyBG }}>
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.3 }}
                        transition={{ duration: 0.6 }}
                    >
                        <Grid container spacing={4} alignItems="flex-start">
                            <Grid item xs={12} md={6}>
                                <Typography variant="h5" sx={{ textTransform: 'uppercase', mb: 1 }}>Our Mission</Typography>
                                <Typography variant="h3" sx={{ mb: 3 }}>
                                We Empower Children, Educators, and Communities Through Sport 
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant="body2" sx={{ color: COLORS.accentBlackTransparent }}>
                                We create child-centered, inclusive, and engaging Sports & Physical Education experiences that develop physical literacy, confidence, teamwork, and lifelong healthy habits. Through quality coaching, meaningful partnerships, and innovative learning, we aim to make sport an essential part of every child's education. 
                                </Typography>
                            </Grid>
                        </Grid>
                    </motion.div>
                </Container>

                <Container maxWidth="xl" sx={{ pt: 6, pb: 6, backgroundColor: COLORS.greyBG }}>
                    <Grid container spacing={4}>
                        {coreValues.map((value, index) => (
                            <Grid item xs={12} sm={6} md={4} key={index}>
                                <motion.div
                                    initial={{ opacity: 0, y: 40 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true, amount: 0.3 }}
                                    transition={{ duration: 0.5, delay: index * 0.2 }}
                                >
                                    <Box display="flex" alignItems="flex-start" gap={2}>
                                        <CheckCircleIcon
                                            sx={{
                                                fontSize: 40,
                                                color: COLORS.accentLime,
                                                bgcolor: COLORS.accentDarkGreen,
                                                borderRadius: '50%',
                                                p: 0.5,
                                            }}
                                        />
                                        <Box>
                                            <Typography variant="h4" sx={{ mb: 1 }}>{value.title}</Typography>
                                            <Typography variant="body2" sx={{ color: COLORS.accentBlackTransparent, fontSize: { xs: '0.875rem', md: '0.9375rem' } }}>
                                                {value.description}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </motion.div>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>
        </Box>
    );
};

export default AboutSection;
